<div class="row">
  <div class="col">
    <span>{{ data.message | async }}</span>
  </div>
</div>
<div class="row mt-2">
  <div class="col-6 text-start">
    @if (data.secondaryButtonLabel) {
      <button mat-raised-button (click)="cancel()">{{ data.secondaryButtonLabel | async }}</button>
    }
  </div>
  <div class="col-6 text-end">
    <button mat-raised-button color="primary" (click)="ok()">{{ data.primaryButtonLabel | async }}</button>
  </div>
</div>
